export default __webpack_public_path__ + "visualize-everything.png";